import { render, staticRenderFns } from "./TestQuestionsList.vue?vue&type=template&id=75844a8a&"
import script from "./TestQuestionsList.vue?vue&type=script&lang=ts&"
export * from "./TestQuestionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports